import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { PLAN_DETAILS } from '../../../../../config/constants';
import { getContextStores } from '../../../../../context';
import { getAssetStatusesKeyedById, getPlansKeyedByAssetId } from '../../../../../selectors';
import SearchHighlight from '../../../SearchHighlight';
import { PlanStatus, WarningDateTime } from '../../../../atoms';
import styles from './styles.module.less';
import { formatObservationDate, getProjectTimezone } from '../../../../../utils';

interface Props {
  display?: {
    gutter?: [number, number];
    labelColSpan?: number;
    valueColSpan?: number;
    valueColFlex?: string;
  };
  assetId: string
}

const PlanDetails: FC<Props> = ({
  assetId,
  display,
}) => {
  const contextStores = getContextStores();
  const planKeyedByAssetId = getPlansKeyedByAssetId(contextStores);
  const assetStatusesKeyedById = getAssetStatusesKeyedById(contextStores);
  const plan = planKeyedByAssetId.get(assetId);
  const projTimezone = getProjectTimezone();

  const renderDetail = (column) => {
    const { key, custom } = column;
    const {
      bandColor, bandDanger, daysUntilDueDate, planStatus,
    } = plan;

    switch (custom) {
      case 'status': {
        const status = assetStatusesKeyedById.get(plan[key])?.label || '';
        return <SearchHighlight text={status} />;
      }
      case 'formatExpiredDate': {
        const displayedStatusUpdatedDate = formatObservationDate(plan[key], projTimezone);
        return (
          <WarningDateTime
            date={displayedStatusUpdatedDate}
            dangerColor={bandColor}
            daysUntilDueDate={daysUntilDueDate}
            danger={bandDanger}
          />
        );
      }

      case 'planStatus':
        return <PlanStatus label={planStatus} color={bandColor} />;

      default:
        return null;
    }
  };

  const renderPlanDetailRow = () => PLAN_DETAILS.map((column) => {
    const { key, title } = column;
    return (
      <span key={key}>
        <Row gutter={display?.gutter} className={styles.planDetailContainer}>
          <Col span={display?.labelColSpan}>
            <span>{title}</span>
          </Col>
          <Col
            span={display?.valueColSpan}
            flex={display?.valueColFlex}
            style={{ textAlign: 'right' }}
          >
            {renderDetail(column)}
          </Col>
        </Row>
      </span>
    );
  });
  return <>{renderPlanDetailRow()}</>;
};

export default PlanDetails;
